import { render, staticRenderFns } from "./ChevronDownRounded.vue?vue&type=template&id=08360d77&scoped=true"
import script from "./ChevronDownRounded.vue?vue&type=script&lang=js"
export * from "./ChevronDownRounded.vue?vue&type=script&lang=js"
import style0 from "./ChevronDownRounded.vue?vue&type=style&index=0&id=08360d77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08360d77",
  null
  
)

export default component.exports